import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import SwitchManagementLayer from '../components/SwitchManagementLayer'

const SwitchManagementPage = () => {
  return (
    <>

    {/* MasterLayout */}
    <MasterLayout>

      {/* Breadcrumb */}
      <Breadcrumb title="Switch Management" />

      {/* RoleAccessLayer */}
      <SwitchManagementLayer />

    </MasterLayout>

  </>
  )
}

export default SwitchManagementPage